import { Section } from '../../app/aml-score/config/aml-score-model';

export const getAmlScoreConfig = (): Section[] => {
  const AML_SCORE_CONFIG: Section[] = [
    {
      id: 'A',
      title: 'A. Aspetti connessi al cliente',
      questions: [
        {
          id: 'A1',
          description: 'Natura giuridica',
          weight: 1,
          options: [
            { view: 'Ditta Individuale', value: 1, id: '1' },
            { view: 'Associazione Professionale', value: 1, id: '2' },
            { view: 'Società di Persone', value: 2, id: '3' },
            { view: 'Società di Capitali', value: 3, id: '4' },
            { view: 'Altro', value: 3, id: '5' },
          ],
        },
        {
          id: 'A2',
          description: 'Prevalente attività svolta',
          weight: 1,
          options: [
            { view: 'Operazioni "normali"', value: 1, id: '1' },
            { view: 'Operazioni particolare rilevanza', value: 3, id: '2' },
            { view: 'Operazioni "anomale"', value: 36, id: '3' },
          ],
        },
        {
          id: 'A3',
          description:
            "Comportamento tenuto al momento dell'operazione dall'esecutore",
          weight: 1,
          options: [
            {
              view: 'Nella norma (cliente collaborativo/trasparente)',
              value: 1,
              id: '1',
            },
            {
              view: 'Fuori dalla norma (cliente reticente/poco trasparente)',
              value: 8,
              id: '2',
            },
          ],
        },
        {
          id: 'A4',
          description: 'Area Geografica di residenza del T.E e/o L.R.',
          weight: 1,
          options: [
            { view: 'Italia', value: 1, id: '1' },
            { view: 'Paesi UE', value: 2, id: '2' },
            { view: 'Paesi extra UE', value: 15, id: '3' },
            { view: 'Territori off shore', value: 36, id: '4' },
          ],
        },
      ],
    },
    {
      id: 'B',
      title: "B. Aspetti connessi all'operazione",
      questions: [
        {
          id: 'B1',
          description: 'Tipologia',
          weight: 1,
          options: [
            { view: 'Ordinaria', value: 1, id: '1' },
            { view: 'Straordinaria', value: 3, id: '2' },
          ],
        },
        {
          id: 'B2',
          description: 'Modalità di svolgimento	',
          weight: 1,
          options: [
            { view: 'Con banche - Intermediari finanziari', value: 1, id: '1' },
            { view: 'Tra soggetti privati', value: 3, id: '2' },
          ],
        },
        {
          id: 'B3',
          description: 'Ammontare',
          weight: 1,
          options: [
            { view: 'Basso', value: 1, id: '1' },
            { view: 'Medio', value: 5, id: '2' },
            { view: 'Alto', value: 10, id: '3' },
          ],
          disabled: true,
        },
        {
          id: 'B4',
          description: 'Frequenza e durata',
          weight: 1,
          options: [
            { view: 'Occasionale', value: 1, id: '1' },
            { view: 'Poco frequente', value: 2, id: '2' },
            { view: 'Frequente', value: 3, id: '3' },
          ],
        },
        {
          id: 'B5',
          description: 'Ragionevolezza',
          weight: 1,
          options: [
            { view: 'Congrua', value: 1, id: '1' },
            { view: 'Non Congrua', value: 20, id: '2' },
          ],
        },
        {
          id: 'B6',
          description: 'Area geografica di destinazione',
          weight: 1,
          options: [
            { view: 'Italia', value: 1, id: '1' },
            { view: 'Paesi UE', value: 2, id: '2' },
            { view: 'Paesi extra UE', value: 15, id: '3' },
            { view: 'Territori off shore', value: 36, id: '4' },
          ],
        },
      ],
    },
    {
      id: 'C',
      title: "C. Aspetti relativi ai soggetti inerenti l'azienda",
      questions: [
        {
          id: 'C1',
          description: 'informazioni eventi negativi',
          weight: 1,
          options: [
            { view: 'Nessuna Anomalia', value: 0, id: '1' },
            { view: 'Legale Rappresentante', value: 12, id: '2' },
            { view: 'Titolari Effettivi', value: 12, id: '3' },
            { view: 'Soci', value: 12, id: '4' },
            { view: 'Garanti', value: 12, id: '5' },
          ],
        },
        {
          id: 'C2',
          description: 'Presenza PEP',
          weight: 1,
          options: [
            { view: 'Si', value: 36, id: '1' },
            { view: 'No', value: 0, id: '2' },
          ],
        },
        {
          id: 'C3',
          description: "all'interno della compagine sociale sono presenti:",
          weight: 1,
          options: [
            { view: 'Trust', value: 10, id: '1' },
            { view: 'Fiduciaria', value: 10, id: '2' },
            { view: 'Ente della PA', value: 10, id: '3' },
            { view: 'Società di Diritto Estero', value: 10, id: '4' },
            { view: 'Nessuna delle precedenti', value: 0, id: '5' },
          ],
        },
        {
          id: 'C4',
          description:
            'NOMINATIVI LISTE ANTITERR. NEI TIT.EFF/O SOGG. DELEGATI',
          weight: 1,
          options: [
            { view: 'Presente', value: 36, id: '1' },
            { view: 'Non Presente', value: 0, id: '2' },
          ],
        },
        {
          id: 'C5',
          description:
            'Vi sono o vi sono stati procedimenti penali o procedimenti per danno erariale, per responsabilità amministrativa ai sensi del D.lgs. 231/01 e/o per irrogazione di sanzioni amministrative ai sensi del D.lgs. 231/07 a carico del cliente o a carico di soggetti legati al cliente (titolari effettivi, esecutori, loro familiari)',
          weight: 1,
          options: [
            { view: 'Presente', value: 20, id: '1' },
            { view: 'Non Presente', value: 0, id: '2' },
          ],
        },
        {
          id: 'C6',
          description: 'Informazioni da fonti aperte',
          weight: 1,
          options: [
            { view: 'Presente', value: 0, id: '1' },
            { view: 'Non Presente', value: 0, id: '2' },
          ],
        },
      ],
    },
  ];
  return AML_SCORE_CONFIG;
};
